import { render } from "./DownTriangleIcon.vue?vue&type=template&id=80726968&scoped=true"
import script from "./DownTriangleIcon.vue?vue&type=script&lang=js"
export * from "./DownTriangleIcon.vue?vue&type=script&lang=js"

import "./DownTriangleIcon.vue?vue&type=style&index=0&id=80726968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80726968"

export default script